import { FloatButton } from 'antd';
import type React from 'react';
import { RiArrowUpLine } from 'react-icons/ri';
import styles from './ScrollToTop.module.css';

const ScrollToTop: React.FC = () => {
  return <FloatButton.BackTop icon={<RiArrowUpLine />} className={styles.wrapper} />;
};

export default ScrollToTop;
